const UNKNOWN_RATIO = -1;
const NOT_VISIBLE_RATIO = 0;
const FULLY_VISIBLE_RATIO = 1;

const roundToOneDecimal = (value) => Math.round(value * 10) / 10;

const getElementVisibilityRatioAlongYAxis = (element) => {
  const liveDocument = element.ownerDocument;
  const windowHeight = liveDocument.defaultView?.innerHeight || 0;
  const hasViewportHeight = windowHeight > 0;

  if (!hasViewportHeight) {
    return UNKNOWN_RATIO;
  }

  const rect = element.getBoundingClientRect();
  const isElementOutsideViewport = rect.bottom <= 0 || rect.top >= windowHeight;

  if (isElementOutsideViewport) {
    return NOT_VISIBLE_RATIO;
  }

  const isElementFullyVisible = rect.top >= 0 && rect.bottom <= windowHeight;

  if (isElementFullyVisible) {
    return FULLY_VISIBLE_RATIO;
  }

  const visibleTop = Math.max(0, rect.top);
  const visibleBottom = Math.min(windowHeight, rect.bottom);
  const visibleHeight = visibleBottom - visibleTop;
  const ratio = visibleHeight / windowHeight;

  return roundToOneDecimal(ratio);
};

export default getElementVisibilityRatioAlongYAxis;
